function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.promise.finally.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import React from 'react';
import { base64ToDataUrl, dataUrlToFile, uInt8ToFile } from "../../utils";
import { ViewArchiveErrorType } from "../view-archive.vm";
import { getBlobUrl, getDownloadProgressLength } from "../../hooks";
import { printFile } from "../tools/print";
export const useArchivePrint = archive => {
  const [loading, setLoading] = React.useState(false);
  const [progress, setProgress] = React.useState(null);
  const [error, setError] = React.useState(null);
  const controller = React.useRef(new AbortController());
  const cancelUrlToDownload = React.useCallback(() => {
    controller.current.abort();
    controller.current = new AbortController();
  }, []);
  React.useEffect(() => {
    return () => controller.current.abort();
  }, []);
  const urlToPrint = React.useCallback((url, config) => {
    setLoading(true);
    getBlobUrl(url, _objectSpread(_objectSpread({}, config), {}, {
      signal: controller.current.signal,
      onDownloadProgress: e => {
        const totalLength = getDownloadProgressLength(e);
        if (totalLength) {
          setProgress({
            loaded: e.loaded,
            total: totalLength,
            percentage: Math.round(e.loaded * 100 / totalLength)
          });
        }
      }
    })).then(({
      data
    }) => printFile(data)).catch(() => setError(ViewArchiveErrorType.DOWNLOAD_ERROR)).finally(() => {
      setLoading(false);
      setProgress(null);
    });
  }, []);
  const print = React.useCallback(options => {
    var _ref, _options$archive;
    const dArchive = (_ref = (_options$archive = options === null || options === void 0 ? void 0 : options.archive) !== null && _options$archive !== void 0 ? _options$archive : archive) !== null && _ref !== void 0 ? _ref : {};
    setError(null);
    const {
      file,
      blob,
      httpUrl,
      staticUrl,
      dataUrl,
      base64,
      uInt8
    } = dArchive;
    if (file) printFile(file);else if (blob) printFile(blob);else if (httpUrl) urlToPrint(httpUrl.url, httpUrl.config);else if (dataUrl) printFile(dataUrlToFile(dataUrl, 'print-file'));else if (base64) printFile(dataUrlToFile(base64ToDataUrl(base64.data, base64.mime), 'print-file'));else if (uInt8) printFile(uInt8ToFile(uInt8.data, uInt8.mime, 'print-file'));else if (staticUrl) urlToPrint(staticUrl.url);else setError(ViewArchiveErrorType.NO_ARCHIVE);
  }, [archive]);
  return [print, {
    error,
    loading,
    progress
  }, cancelUrlToDownload];
};